<div class="pellets-einblasen-outer">
  <div class="section">
    <!-- Wiegung LKW -->
    <div class="wiegeungen-outer" [class.anhanger-waage-vorhanden]="isAnhangerWaageVorhanden">
      <!-- Erstwiegung -->
      <div class="wiegung-container" [class.wiegungErfolgreich]="wiegung1.Erfolgreich">
        <h1>{{ '1. Wiegung LKW' | translate }}</h1>

        <div class="wiegung-ausgabe">
          <span *ngIf="wiegung1.Erfolgreich">{{ wiegung1.Gewicht | number : '1.0-0' }} kg</span>
          <span class="handeingabe" *ngIf="wiegung1.Typ === 2">{{ 'Handeingabe' | translate }}</span>
        </div>

        <div *ngIf="!wiegung1.Erfolgreich && !wiegung2.Erfolgreich" class="button-group-1">
          <ion-button color="light" expand="block" appClick (clicked)="onErstwiegung('Fahrzeug')" class="icon-button-with-text button-border" [size]="buttonSize">
            {{ '1. Wiegung' | translate }}
          </ion-button>

          <ion-button color="light" expand="block" appClick (clicked)="onHandeingabe(1)" class="icon-button-with-text button-border" [size]="buttonSize" *ngIf="isHandeingabeErlaubt">
            {{ 'Handeingabe' | translate }}
          </ion-button>
        </div>

        <ion-button color="light" expand="block" appClick (clicked)="onWiegungLoeschen(1)" class="icon-button-with-text button-border" [size]="buttonSize" *ngIf="wiegung1.Erfolgreich && !wiegung2.Erfolgreich">
          {{ 'Löschen' | translate }}
        </ion-button>
      </div>

      <!-- Zweitwiegung-->
      <div class="wiegung-container" [class.disabled]="!wiegung1.Erfolgreich" [class.wiegungErfolgreich]="wiegung2.Erfolgreich">
        <h1>{{ '2. Wiegung LKW' | translate }}</h1>

        <div class="wiegung-ausgabe">
          <span *ngIf="wiegung2.Erfolgreich">{{ wiegung2.Gewicht | number : '1.0-0' }} kg</span>
          <span class="handeingabe" *ngIf="wiegung2.Typ === 2">{{ 'Handeingabe' | translate }}</span>
        </div>

        <div *ngIf="wiegung1.Erfolgreich && !wiegung2.Erfolgreich" class="button-group-1">
          <ion-button color="light" [expand]="buttonExpand" appClick (clicked)="onZweitwiegung('Fahrzeug')" class="icon-button-with-text button-border" [size]="buttonSize">
            {{ '2. Wiegung' | translate }}
          </ion-button>

          <ion-button color="light" [expand]="buttonExpand" appClick (clicked)="onHandeingabe(2)" class="icon-button-with-text button-border" [size]="buttonSize" *ngIf="isHandeingabeErlaubt">
            {{ 'Handeingabe' | translate }}
          </ion-button>
        </div>

        <ion-button color="light" expand="block" appClick (clicked)="onWiegungLoeschen(2)" class="icon-button-with-text button-border" [size]="buttonSize" *ngIf="wiegung2.Erfolgreich">
          {{ 'Löschen' | translate }}
        </ion-button>
      </div>
    </div>

    <!-- Wiegung Anhänger -->
    <div class="wiegeungen-outer wiegeungen-outer-anhanger anhanger-waage-vorhanden" *ngIf="isAnhangerWaageVorhanden">
      <!-- Erstwiegung Anhänger -->
      <div class="wiegung-container" [class.wiegungErfolgreich]="wiegung3.Erfolgreich">
        <h1>{{ '3. Wiegung Anhänger' | translate }}</h1>

        <div class="wiegung-ausgabe">
          <span *ngIf="wiegung3.Erfolgreich">{{ wiegung3.Gewicht | number : '1.0-0' }} kg</span>
          <span class="handeingabe" *ngIf="wiegung3.Typ === 2">{{ 'Handeingabe' | translate }}</span>
        </div>

        <div *ngIf="!wiegung3.Erfolgreich && !wiegung4.Erfolgreich" class="button-group-1">
          <ion-button color="light" expand="block" appClick (clicked)="onErstwiegung('Anhaenger')" class="icon-button-with-text button-border" [size]="buttonSize">
            {{ '3. Wiegung' | translate }}
          </ion-button>

          <ion-button color="light" expand="block" appClick (clicked)="onHandeingabe(3)" class="icon-button-with-text button-border" [size]="buttonSize" *ngIf="isHandeingabeErlaubt">
            {{ 'Handeingabe' | translate }}
          </ion-button>
        </div>

        <ion-button color="light" expand="block" appClick (clicked)="onWiegungLoeschen(3)" class="icon-button-with-text button-border" [size]="buttonSize" *ngIf="wiegung3.Erfolgreich && !wiegung4.Erfolgreich">
          {{ 'Löschen' | translate }}
        </ion-button>
      </div>

      <!-- Zweitwiegung Anhänger -->
      <div class="wiegung-container" [class.disabled]="!wiegung3.Erfolgreich" [class.wiegungErfolgreich]="wiegung4.Erfolgreich">
        <h1>{{ '4. Wiegung Anhänger' | translate }}</h1>

        <div class="wiegung-ausgabe">
          <span *ngIf="wiegung4.Erfolgreich">{{ wiegung4.Gewicht | number : '1.0-0' }} kg</span>
          <span class="handeingabe" *ngIf="wiegung4.Typ === 2">{{ 'Handeingabe' | translate }}</span>
        </div>

        <div *ngIf="wiegung3.Erfolgreich && !wiegung4.Erfolgreich" class="button-group-1">
          <ion-button color="light" expand="block" appClick (clicked)="onZweitwiegung('Anhaenger')" class="icon-button-with-text button-border" [size]="buttonSize">
            {{ '4. Wiegung' | translate }}
          </ion-button>

          <ion-button color="light" expand="block" appClick (clicked)="onHandeingabe(4)" class="icon-button-with-text button-border" [size]="buttonSize" *ngIf="isHandeingabeErlaubt">
            {{ 'Handeingabe' | translate }}
          </ion-button>
        </div>


        <ion-button color="light" expand="block" appClick (clicked)="onWiegungLoeschen(4)" class="icon-button-with-text button-border" [size]="buttonSize" *ngIf="wiegung4.Erfolgreich">
          {{ 'Löschen' | translate }}
        </ion-button>
      </div>
    </div>

    <div class="wiegung-ergebnis" *ngIf="wiegung2.Erfolgreich || wiegung4.Erfolgreich" [class.anhanger-waage-vorhanden]="isAnhangerWaageVorhanden">
      <div class="netto-text">{{ 'Netto' | translate }}</div>
      <div class="wiegeung-text">{{nettoGewicht | number : '1.0-0' }} kg</div>
    </div>

  </div>

</div>